import { useState, useEffect } from 'react';

// Global buffer: captura o evento mesmo antes do componente montar
if (typeof window !== 'undefined') {
  window.__pwaPrompt = window.__pwaPrompt || null;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__pwaPrompt = e;
    // Notifica qualquer listener registrado
    window.dispatchEvent(new Event('pwa-prompt-ready'));
  });
}

export function usePWA() {
  const [installPrompt, setInstallPrompt] = useState(() => window.__pwaPrompt || null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOSHint, setShowIOSHint] = useState(false);

  useEffect(() => {
    // Detecta iOS
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(ios);

    // Detecta se já está instalado (modo standalone)
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setIsInstalled(standalone);

    if (ios && !standalone) {
      const dismissed = localStorage.getItem('pwa-ios-dismissed');
      if (!dismissed) setShowIOSHint(true);
    }

    // Se o evento já disparou antes da montagem, captura do buffer
    if (window.__pwaPrompt) {
      setInstallPrompt(window.__pwaPrompt);
    }

    // Escuta novos eventos (caso ainda não tenha disparado)
    const onPromptReady = () => {
      if (window.__pwaPrompt) setInstallPrompt(window.__pwaPrompt);
    };
    window.addEventListener('pwa-prompt-ready', onPromptReady);
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setInstallPrompt(null);
      window.__pwaPrompt = null;
    });

    return () => {
      window.removeEventListener('pwa-prompt-ready', onPromptReady);
    };
  }, []);

  const install = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') setIsInstalled(true);
    setInstallPrompt(null);
    window.__pwaPrompt = null;
  };

  const dismissIOSHint = () => {
    setShowIOSHint(false);
    localStorage.setItem('pwa-ios-dismissed', '1');
  };

  const dismiss = () => {
    setInstallPrompt(null);
    window.__pwaPrompt = null;
    sessionStorage.setItem('pwa-banner-dismissed', '1');
  };

  // Não mostrar se já foi dispensado nesta sessão
  const sessionDismissed = sessionStorage.getItem('pwa-banner-dismissed') === '1';

  return {
    installPrompt: sessionDismissed ? null : installPrompt,
    isInstalled,
    isIOS,
    showIOSHint,
    install,
    dismiss,
    dismissIOSHint,
  };
}
